@if ({
  pageName: pageName$ | async,
  templateName: templateName$ | async,
  }; as content) {
  <h1>
    @if (content.templateName === 'SearchResultsListPageTemplate' || content.templateName === 'SearchResultsGridPageTemplate') {
      {{ 'category.search.title' | cxTranslate }}
    }
    <span>
      {{ content.pageName }}
    </span>
  </h1>
}
